// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/global.css");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/variables.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".dialog_925.dialog_925 {\n  width: auto;\n  max-width: 400px;\n}\n\n.content_ca6 {\n\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  margin: 32px;\n}\n\n.button_0c2 {\n  width: 200px;\n  margin-top: 8px;\n}\n\n.firstButton_b4d {\n\n  margin-top: 32px;\n}\n\n.title_05f {\n  margin-bottom: 8px;\n\n  text-align: center;\n\n  font-size: 24px;\n  font-weight: 100;\n  line-height: 28px;\n}\n\n.logo_1ea {\n  width: 96px;\n  height: 96px;\n  margin-bottom: 12px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n\n.error_3ec {\n  text-align: center;\n\n  color: #c22731;\n\n  color: var(--ring-error-color);\n}\n", ""]);
// Exports
exports.locals = {
	"unit": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["unit"] + "",
	"dialog": "dialog_925",
	"content": "content_ca6 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["font"] + "",
	"button": "button_0c2",
	"firstButton": "firstButton_b4d button_0c2",
	"title": "title_05f",
	"logo": "logo_1ea",
	"error": "error_3ec"
};
module.exports = exports;
